import React, { useState, useRef } from "react";
import { Container, Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import MinuteByMinuteHeader from "./MinuteByMinuteHeader";
import { useWindowVirtualizer } from "@tanstack/react-virtual";
import MinuteByMinuteRow from "./MinuteByMinuteRow";
import moment from "moment/min/moment-with-locales";
import SongCatalogueModal from "../songCatalogue/SongCatalogueModal";

export default function MinuteByMinuteTable({ sortConfig, requestSort, data }) {
    const [catalogueSong, setCatalogueSong] = useState(null);

    const tableContainerRef = useRef(null);

    const virtualizer = useWindowVirtualizer({
        count: data?.length || 1,
        estimateSize: () => 32,
        overscan: 40,
        scrollMargin: tableContainerRef.current?.offsetTop ?? 0,
    });

    return (
        <>
            <MinuteByMinuteHeader sortConfig={sortConfig} requestSort={requestSort} />
            <div ref={tableContainerRef}>
                <Container fluid className="position-relative" style={{ height: virtualizer.getTotalSize() }}>
                    {virtualizer.getVirtualItems().map(virtualRow => {
                        const item = data[virtualRow.index];
                        const nextItem = data[virtualRow.index + 1];
                        const crossedHour = nextItem
                            ? moment(item.played_at).dayOfYear() !== moment(nextItem.played_at).dayOfYear() ||
                              moment(item.played_at).hour() !== moment(nextItem.played_at).hour()
                            : false;

                        if (!item) {
                            return (
                                <Row
                                    key={virtualRow.key}
                                    data-index={virtualRow.index}
                                    ref={virtualizer.measureElement}
                                    style={{ transform: `translateY(${virtualRow.start - virtualizer.options.scrollMargin}px)` }}
                                    className="py-2 border-bottom position-absolute w-100 pe-2">
                                    <Col className="text-center">No results found</Col>
                                </Row>
                            );
                        }
                        return (
                            <MinuteByMinuteRow
                                key={virtualRow.key}
                                item={item}
                                virtualizer={virtualizer}
                                virtualRow={virtualRow}
                                setCatalogueSong={setCatalogueSong}
                                hourSeparator={crossedHour}
                            />
                        );
                    })}
                </Container>
            </div>
            <SongCatalogueModal show={!!catalogueSong} onHide={() => setCatalogueSong(null)} song={catalogueSong} />
        </>
    );
}
